module.exports = __webpack_public_path__ + "static/media/taxation.a4626a5f.jpg";